import platform from '@intercom/embercom-composer/lib/platform';
import $ from 'jquery';
import { schedule } from '@ember/runloop';
import Em from 'ember';
export default Em.Component.extend({
  classNames: ['m__composer-help__container'],
  isVisible: false,
  targetContainerSelector: null,
  modifierKey: platform.get('modifierKeyName'),
  didInsertElement() {
    this._super(...arguments);
    this.set('parentComposerId', $(this.element).closest('.embercom-composer').attr('id'));
    this.set('targetContainerSelector', $('#ember-testing').length ? '#ember-testing' : 'body');
  },
  showOrHideModal: Em.observer({
    dependentKeys: ['isVisible'],
    fn() {
      if (this.get('isVisible')) {
        schedule('afterRender', this, function () {
          // eslint-disable-next-line jquery-unsafe/no-append
          $(this.get('targetContainerSelector')).append($(this.element));
          $('.new_pattern_area', this.element).focus();
        });
      } else {
        let $helpContainer = $(this.get('parentComposerId')).find('.composer-help-container');
        let $helpGuide = $(`#${this.get('elementId')}`);
        /* @pat - This lint is okay to disable as we are just moving an existing element */
        /* eslint-disable-next-line jquery-unsafe/no-appendTo */
        $helpGuide.appendTo($helpContainer);
      }
    },
    sync: true
  }),
  click(e) {
    if (!$(e.target).closest('.m__composer-help').length) {
      this.send('closeModal');
    }
  },
  keyDown(e) {
    let key = e.which || e.keyCode;
    if (key === 27) {
      this.send('closeModal');
    }
  },
  actions: {
    closeModal() {
      this.set('isVisible', false);
    }
  }
});